import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bsclose-icon',
	templateUrl:'./BSCloseIconPage.html',
	styles: [],
	styleUrls:['./BSCloseIconPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSCloseIconPage
{
	mdContent_89 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.close.BSCloseIcon;
\`\`\``;
	mdContent_90 = `\`\`\`java
new BSCloseIcon<>()
\`\`\``;
	mdContent_91 = `\`\`\`java
var alert = new BSAlertDanger<>();
alert.setText("Error occurred!");
var close = new BSCloseIcon<>();
alert.add(close);
\`\`\``;
}
